import axios from 'CanExConfig/axios'

const workHistoriesEndpoint = candidateProfileId => `/api/candidate/v2/candidate_profiles/${candidateProfileId}/work_histories`
const workHistoryEndpoint = workHistoryId => `/api/candidate/v2/work_histories/${workHistoryId}`

export const fetchWorkHistory = async id => {
  const response = await axios.get(workHistoriesEndpoint(id))
  return response.data.result
}

export const updateWorkHistory = async (id, data) => {
  const response = await axios(workHistoryEndpoint(id), {
    method: 'PATCH',
    data,
  })

  return response.data.result
}

export const createWorkHistory = async (id, data) => {
  const response = await axios(workHistoriesEndpoint(id), {
    method: 'POST',
    data,
  })

  return response.data.result
}

export const deleteWorkHistory = async id => {
  const response = await axios(workHistoryEndpoint(id), {
    method: 'DELETE',
  })

  return response.data.result
}
